import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class AppComponent {
  constructor() {
    this.initHubSpot();
  }

  private initHubSpot() {
    // HubSpot logic
    const url = window.location.href;
    if (environment.chatEnabled && url.indexOf('/azn/') !== -1) {
      const script = document.createElement("script");
      script.src = "//js-eu1.hs-scripts.com/142675568.js";
      script.type = "text/javascript";
      script.id = "hs-script-loader";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }
  }
}
